exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card_text {\n  overflow: hidden;\n  color: black;\n  font-size: 16px !important;\n  text-decoration: none;\n  height: 40px;\n  line-height: 1.4;\n}\np.card_text {\n  margin: 0 !important;\n}\n.badge_green{\n  color: #338e4c !important;\n}\n.badge_yellow{\n  color: darkorange !important;\n}\n.badge_red{\n  color: #d13322 !important;\n}\n.my_badge{\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n", ""]);

// exports
